export default "__VITE_ASSET__B2v$uI_U__"